import translations from 'shared/genesis-locales';

/**
 * Isomorphic gettext
 * @param {String} key key of string.
 * @param {Object} [req] on server, pass express req.
 * @return {String}
 */
export default function gettext(key, req) {
  const trans = translations[key];
  let lang = 'en';

  if (typeof window !== 'undefined') {
    lang = window.__APP_LANGUAGE__;
  } else if (req) {
    const { session } = req;

    lang = session.selectedLanguage || session.language;
  }

  if (!trans) {
    throw new Error(`No translation found for key: ${key}`);
  }
  return trans[lang];
}

export function t(key, region) {
  let lang = 'en';

  if (region === 'CN') {
    lang = 'zh';
  }

  const trans = translations[key];

  return trans[lang];
}
